import { render, staticRenderFns } from "./MediaTypeIcon.vue?vue&type=template&id=2cd2f24a&"
import script from "./MediaTypeIcon.vue?vue&type=script&lang=js&"
export * from "./MediaTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports